import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api } from '../api/client';

/* ============================================================
   WinesContext — catálogo de vinhos vindo da API
   ============================================================
   Carrega no arranque da aplicação (mesmo padrão do
   CartContext/LanguageContext) para que páginas e o overlay de
   navegação não façam pedidos repetidos. Expõe `refetch` para
   que o utilizador consiga recuperar de uma falha pontual (ex.
   backend momentaneamente indisponível) sem ter de recarregar a
   página inteira.
   ============================================================ */

const WinesContext = createContext(null);

export function WinesProvider({ children }) {
  const [wines, setWines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchWines = useCallback(() => {
    setLoading(true);
    setError(null);
    return api.getWines()
      .then((data) => setWines(data))
      .catch((e) => setError(e))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    let cancelled = false;

    setLoading(true);
    api.getWines()
      .then((data) => {
        if (!cancelled) setWines(data);
      })
      .catch((e) => {
        if (!cancelled) setError(e);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, []);

  return (
    <WinesContext.Provider value={{ wines, loading, error, refetch: fetchWines }}>
      {children}
    </WinesContext.Provider>
  );
}

export function useWines() {
  const ctx = useContext(WinesContext);
  if (!ctx) {
    throw new Error('useWines deve ser usado dentro de um <WinesProvider>');
  }
  return ctx;
}
